import { UntypedFormBuilder, Validators, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ProgramCategoryEdit } from 'src/app/program/model/programCategoryEdit';
import { merge } from 'lodash';
import { ProgramValidators } from 'src/app/core/validators/program.validators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-program-category-edit',
  templateUrl: './program-category-edit.component.html',
  styleUrls: ['./program-category-edit.component.scss']
})
export class ProgramCategoryEditComponent
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<ProgramCategoryEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;

  private programCategoryEdit: ProgramCategoryEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private programValidators: ProgramValidators)
  { }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  @Input() public set model(programCategory: ProgramCategoryEdit)
  {
    this.initModel(programCategory);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();
    const objectToPersist = merge(this.programCategoryEdit, this.editForm.value);

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(programCategory: ProgramCategoryEdit)
  {
    if (programCategory === undefined)
    {
      return;
    }
    // Set the current program category id used for name async validators
    const previousProgramCategoryName = this.isNew ? '' : programCategory.name;

    // Set form
    this.editForm = this.fb.group({
      id: [null],
      name: [
        { value: '', disabled: false },
        {
          validators: [Validators.required],
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.programValidators.validateProgramCategoryNameUnique(this.editForm.get('name'), previousProgramCategoryName)
        }
      ],
      active: { value: true, disabled: false }
    });

    this.editForm.reset(programCategory);
    this.programCategoryEdit = programCategory;
    this.editFormActive = programCategory !== undefined;
  }
}
